import { action } from 'satcheljs';
import type { CalendarComposeInitializationConfig } from 'owa-calendar-helpers-types/lib/CalendarComposeInitializationConfig';
import type { CustomData } from 'owa-analytics-types';
import type UnifiedTelemetryContext from 'owa-calendar-unified-telemetry-utils/lib/types/UnifiedTelemetryContext';
import type { LaunchCalendarFullComposeActionMessage } from './launchCalendarFullCompose';

export type LaunchCalendarFullComposeWithConfirmationActionMessage =
    LaunchCalendarFullComposeActionMessage;

export const launchCalendarFullComposeWithConfirmation: (
    config: CalendarComposeInitializationConfig,
    freezeDryId?: string,
    customStartTime?: number,
    targetWindow?: Window,
    otherData?: CustomData,
    deskComposeAllowed?: boolean,
    openInNewWindow?: boolean,
    unifiedEventTelemetryContext?: UnifiedTelemetryContext
) => LaunchCalendarFullComposeWithConfirmationActionMessage = action(
    'launchCalendarFullComposeWithConfirmation',
    (
        config: CalendarComposeInitializationConfig,
        freezeDryId?: string,
        customStartTime?: number,
        targetWindow?: Window,
        otherData?: CustomData,
        deskComposeAllowed = true,
        openInNewWindow?: boolean,
        unifiedEventTelemetryContext?: UnifiedTelemetryContext
    ): LaunchCalendarFullComposeWithConfirmationActionMessage => ({
        config,
        freezeDryId,
        customStartTime,
        targetWindow,
        otherData,
        deskComposeAllowed,
        openInNewWindow,
        unifiedEventTelemetryContext,
    })
);
